import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Zap } from 'lucide-react';
export function WorkflowTotal() {
  const comparison = [{
    bad: 'Usás cada IA de forma aislada',
    good: 'Las 3 IAs trabajan en cadena como un equipo'
  }, {
    bad: 'Perdés contexto al pasar de una IA a otra',
    good: 'Los Prompts de Cadena mantienen la coherencia'
  }, {
    bad: 'Resultados inconsistentes por tarea',
    good: 'Cada IA hace lo que mejor sabe hacer'
  }, {
    bad: 'Improvisás el orden de trabajo',
    good: 'Tenés un sistema probado para cada operación'
  }, {
    bad: 'Cada proyecto empieza de cero',
    good: 'Los workflows se reutilizan en minutos'
  }];
  const operations = [{
    num: '1',
    title: 'Ventas: De la idea al cierre',
    desc: 'DeepSeek analiza la rentabilidad. ChatGPT crea el guión. Claude humaniza el mensaje.'
  }, {
    num: '2',
    title: 'Contenido: De la métrica al post viral',
    desc: 'DeepSeek detecta qué temas traen resultados. ChatGPT genera los ángulos. Claude escribe con tu voz.'
  }, {
    num: '3',
    title: 'Lanzamiento en 48hs',
    desc: 'ChatGPT estructura el programa. DeepSeek valida el precio. Claude escribe la carta de ventas.'
  }, {
    num: '4',
    title: 'Administración: Orden absoluto',
    desc: 'DeepSeek limpia tu base de datos. ChatGPT responde preguntas frecuentes. Claude resume contratos.'
  }];
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-286">
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-cyan-500/10 rounded-full blur-[150px] pointer-events-none" data-id="element-287"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-289">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/20 border border-orange-500/30 text-orange-400 font-bold mb-6" data-id="element-290">
            <Zap className="w-5 h-5" data-id="element-291" /> UPSELL EXCLUSIVO
          </div>
          <h2 className="text-4xl md:text-6xl font-display font-bold text-white mb-4" data-id="element-292">
            WORKFLOW TOTAL
          </h2>
          <p className="text-2xl text-cyan-400 font-medium mb-8" data-id="element-293">
            El Manual de Operaciones 3-en-1
          </p>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-294">
            Lo que hace que todo lo anterior tenga sentido como sistema. Tener
            ChatGPT, DeepSeek y Claude por separado es como tener un motor,
            cuatro ruedas y un volante tirados en el garage.{' '}
            <strong className="text-white" data-id="element-295">
              El Workflow Total es el chasis que los une.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-296">
          <h3 className="text-2xl font-bold text-center text-white mb-8" data-id="element-297">
            ¿Qué agrega el Workflow Total?
          </h3>
          <div className="glass-card rounded-2xl overflow-hidden border border-white/10" data-id="element-298">
            <div className="grid grid-cols-2 bg-white/5 border-b border-white/10" data-id="element-299">
              <div className="p-4 text-center font-bold text-red-400 flex items-center justify-center gap-2" data-id="element-300">
                <X className="w-5 h-5" data-id="element-301" /> Sin Workflow Total
              </div>
              <div className="p-4 text-center font-bold text-green-400 flex items-center justify-center gap-2 border-l border-white/10 bg-green-500/5" data-id="element-302">
                <Check className="w-5 h-5" data-id="element-303" /> Con Workflow Total
              </div>
            </div>
            {comparison.map((row, i) => <div key={i} className="grid grid-cols-2 border-b border-white/5 last:border-0" data-id="element-304">
                <div className="p-4 text-gray-400 text-sm md:text-base" data-id="element-305">
                  {row.bad}
                </div>
                <div className="p-4 text-white font-medium text-sm md:text-base border-l border-white/10 bg-green-500/5" data-id="element-306">
                  {row.good}
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-307">
          <h3 className="text-2xl font-bold text-center text-white mb-8" data-id="element-308">
            El Workflow Total incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-309">
            {operations.map((op, i) => <div key={i} className="glass-card p-6 rounded-xl border border-cyan-500/20 hover:border-cyan-500/50 transition-colors" data-id="element-310">
                <div className="text-cyan-400 font-bold text-sm mb-2" data-id="element-311">
                  OPERACIÓN {op.num}
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-312">
                  {op.title}
                </h4>
                <p className="text-gray-400" data-id="element-313">{op.desc}</p>
              </div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-314">
            <div className="bg-gradient-to-br from-purple-900/40 to-dark p-6 rounded-xl border border-purple-500/30" data-id="element-315">
              <h4 className="text-lg font-bold text-purple-400 mb-2" data-id="element-316">
                Los Prompts de Cadena
              </h4>
              <p className="text-gray-300 text-sm" data-id="element-317">
                Los puentes de texto para pasar información de una IA a otra sin
                perder calidad ni coherencia.
              </p>
            </div>
            <div className="bg-gradient-to-br from-orange-900/40 to-dark p-6 rounded-xl border border-orange-500/30" data-id="element-318">
              <h4 className="text-lg font-bold text-orange-400 mb-2" data-id="element-319">
                El Protocolo de Conexión
              </h4>
              <p className="text-gray-300 text-sm" data-id="element-320">
                La regla de oro para que DeepSeek, ChatGPT y Claude trabajen
                como un equipo coordinado.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-321">
            <p className="inline-block bg-white/10 px-6 py-3 rounded-full text-white font-bold border border-white/20" data-id="element-322">
              50 páginas de sistemas y workflows aplicados al negocio real.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}